import { render, staticRenderFns } from "./Premium.vue?vue&type=template&id=4864a6f2&"
import script from "./Premium.vue?vue&type=script&setup=true&lang=js&"
export * from "./Premium.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports